export const CLIENT_TYPE_TRIAL = 'trial';
export const CLIENT_TYPE_LIVE = 'live';

export const CLIENT_TYPES = [CLIENT_TYPE_TRIAL, CLIENT_TYPE_LIVE] as const;


// Same values as locker vertical (LockerInterface::VERTICAL_*); labels live in lockers.locker.fields.vertical.values
export const COMMUNITY_VERTICALS = [10, 20, 30, 40, 50, 60] as const;

export const MODULE_SLUG_INTEGRATIONS = 'integrations';
export const MODULE_SLUG_NOTIFICATIONS = 'notifications';
export const NOTIFICATION_CHANNEL_SLUGS = ['email', 'sms', 'push'];
export const NOTIFICATION_CUSTOM_TEMPLATES_SLUG = 'custom-templates';
export const INTEGRATION_COMMUNICATION_SLUGS = ['webhook'];
